/* eslint-disable class-methods-use-this */
import BaseCommand from "../baseCommand";

class DummyCommand extends BaseCommand {
  execute() {}

  undo() {}
}

export default DummyCommand;
